import { Component, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { User } from 'shared/types/user.model';
import { TranslatePipe } from '@ngx-translate/core';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { InvitationTimelineResponse } from 'core/types/invitation.interface';
import { HideTooltipOnScrollDirective } from 'shared/directives';

@Component({
  selector: 'app-journey-tab',
  imports: [TranslatePipe, NzTooltipDirective, HideTooltipOnScrollDirective, DatePipe],
  templateUrl: './journey-tab.component.html',
  styleUrl: './journey-tab.component.scss'
})
export class JourneyTabComponent {
  user = input<User>();
  timeline = input<InvitationTimelineResponse>();
}
